import ProductManager from './ProductManager';

function App() {
  return <ProductManager />;
}

export default App;
